/* eslint-disable no-param-reassign */
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './SearchSortFilterMenu.module.css';
import { Button, PopoverPaper, SearchBar } from '../../../../atomicComponents';
import { AutoSizer, List } from 'react-virtualized';
import { dateFormat } from '../../../../constants/Utils';
import { dateFieldHeader } from '../../../../constants/constVariables';

const SearchSortFilterMenu = ({
  open,
  handleClose,
  filterOptions,
  selectedFilterOptions,
  applyFilters,
  enableSearch,
  enableFilter,
  anchorEl,
  field
}) => {
  const [filterSelections, setFilterSelections] = useState(
    new Set(selectedFilterOptions),
  );
  const [bgColour, setBgColour] = useState()

  const filterOptionsFunc = (optionsToBeFiltered, query) => {
    if (!query) {
      return optionsToBeFiltered;
    }
    const searchedOption = optionsToBeFiltered.filter(option => {
      const optionName = option.toLowerCase();
      const lowerCaseQuery = query.toLowerCase();
      return optionName.includes(lowerCaseQuery);
    });
    return searchedOption;
  };
  const [searchQuery, setSearchQuery] = useState('');
  const filteredOptions = filterOptionsFunc(filterOptions, searchQuery);

  const handleFilterSelection = filterOption => {
    setFilterSelections(prev => {
      const copySet = new Set(prev);
      if (copySet.delete(filterOption)) {
        return copySet;
      }
      return new Set([...copySet, filterOption]);
    });
  };
  // console.log("length = ", filteredOptions.length)
  const selectAllCheckboxRef = useCallback(
    node => {
      if (node !== null) {
        if (
          filterSelections.size &&
          filterSelections.size === filteredOptions.length
        ) {
          node.checked = true;
          node.indeterminate = false;
        } else if (filterSelections.size > 0) {
          node.indeterminate = true;
          node.checked = false;
        } else {
          node.checked = false;
          node.indeterminate = false;
        }
      }
    },
    [filterSelections, filteredOptions],
  );

  useEffect(() => {
    setFilterSelections(new Set(selectedFilterOptions));
  }, [selectedFilterOptions]);
  const noRowsRenderer = () => { return <div>No rows</div> }
  const rowRenderer = ({ index, isScrolling, isVisible, key, parent, style, }) => {
    // console.log("abc = ", index, isScrolling, isVisible, key, parent, style, filteredOptions[index])
    return (
      <>
        <div style={style} key={key}>
          <div
            className={styles.filterOption}
            key={filteredOptions[index]?.value || filteredOptions[index]}
            style={{ display: 'flex', flexDirection: 'row', height: '20px', overflowY: 'hidden' }}
          >
            <>
              <input
                id={`option-${filteredOptions[index]}`}
                data-testid={`option-${filteredOptions[index]}`}
                type="checkbox"
                name={filteredOptions[index]}
                checked={filterSelections.has(filteredOptions[index])}
                onChange={() => {
                  handleFilterSelection(filteredOptions[index]);
                }}
              />
              <label htmlFor={`option-${filteredOptions[index]}`}>{dateFieldHeader.includes(field) ? dateFormat(filteredOptions[index], true) : filteredOptions[index]}</label>
            </>
            {/* <label key={index}>{index}</label> */}
          </div>
        </div>
      </>
    );
  };
  return (
    <PopoverPaper
      open={open}
      handleClose={() => {
        handleClose();
        setSearchQuery('');
      }}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
    >
      <div className={styles.container} style={{ height: `${filteredOptions.length > 0 ? (filteredOptions.length * 30) + 110 : 120}px` }}>
        {enableSearch && (
          <div className={styles.searchBarArea}>
            <SearchBar
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
            />
          </div>
        )}
        {enableFilter && filterOptions?.length > 0 && (
          <>
            <div className={clsx(styles.filterArea, styles.scrollBar)} >
              <div className={styles.filtersList} style={{ height: "100%" }}>
                {/* {filteredOptions?.length > 1 && (
                  <div className={styles.filterOption}>
                    <input
                      ref={selectAllCheckboxRef}
                      name="select-all"
                      type="checkbox"
                      data-testid="select-all-filters"
                      onChange={() => {
                        if (filterSelections.size === filteredOptions.length)
                          setFilterSelections(new Set());
                        else setFilterSelections(new Set(filteredOptions));
                      }}
                    />

                    <label htmlFor="select-all-filters">Select All</label>
                  </div>
                )} */}
                <AutoSizer>
                  {({ width: windowWidth, height: windowHeight }) => {
                    const width = windowWidth;
                    const height = windowHeight;
                    const rowHeight = 30;
                    // console.log("autosizer width = ", width)
                    // console.log("autosizer height = ", height)
                    return (
                      <List
                        // ref={vListRef}
                        width={width}
                        height={height}
                        rowCount={filteredOptions.length}
                        rowHeight={rowHeight}
                        rowRenderer={rowRenderer}
                        containerStyle={{ display: "flex", flexDirection: "column", gap: '10px', padding: '5px' }}
                        overscanRowCount={5}
                        noRowsRenderer={noRowsRenderer}
                      />
                    );
                  }}
                </AutoSizer>
              </div>
            </div>

          </>
        )}
        <div className={styles.filterApplyButtons}>
          <Button
            className={clsx(styles.cancelButton, "smallFont")}
            variant="secondary"
            onClick={() => {
              setFilterSelections(new Set(selectedFilterOptions));
              handleClose();
              setSearchQuery('');
            }}

          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.okButton, "smallFont")}
            variant="okButton"
            onClick={() => {
              applyFilters([...filterSelections]);
              handleClose();
              setSearchQuery('');
            }}
            style={{ backgroundColor: bgColour }}
            onMouseEnter={() => setBgColour('#488f71')}
          >
            OK
          </Button>
        </div>
      </div>
    </PopoverPaper>
  );
};

SearchSortFilterMenu.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  selectedFilterOptions: PropTypes.objectOf(Set),
  applyFilters: PropTypes.func,
  filterOptions: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  ),
  enableSearch: PropTypes.bool,
  enableFilter: PropTypes.bool,
  anchorEl: PropTypes.any,
};

export default SearchSortFilterMenu;
